module.exports = __webpack_public_path__ + "assets/img/fix_open_mobile.89a3fa1b.png";